// useAgentDashboardMetrics.js
import { useState, useEffect, useCallback } from "react";
import _ from "lodash";
import { getAgentDashboardMetrics } from "@/services";
import { getUserId } from "@/helpers";
import useAgentGitchaRestrictions from "./useAgentGitchaRestrictions";

const useAgentDashboardMetrics = (scope = "all") => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const userId = getUserId();

  const { shouldRestrictAgent } = useAgentGitchaRestrictions();

  const fetchMetrics = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 200));

      const response = await getAgentDashboardMetrics({ userId, scope, onlySyndicatedListings: shouldRestrictAgent });
      const result = _.get(response, "result", null);
      if (response.errorCode === 0) {
        setData(result);
      } else {
        setError(response);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [userId, scope]);

  useEffect(() => {
    fetchMetrics();
  }, [fetchMetrics]);

  return { data, loading, error, refetch: fetchMetrics };
};

export default useAgentDashboardMetrics;
